var recipe_groups = [
  [
    {
      "output": "block.minecraft.orange_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.azure_bluet"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.white_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oxeye_daisy"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.jungle_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.orange_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fishing_rod",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.repeater",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.warped_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.white_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lily_of_the_valley"
        ]
      ]
    },
    {
      "output": "item.minecraft.white_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.bone_meal"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.light_blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_carpet",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ],
        [
          "block.minecraft.white_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.orange_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.orange_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.yellow_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.netherite_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blue_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.detector_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.stone_pressure_plate"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.orange_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.orange_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.green_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.brown_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.lime_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.blue_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.black_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.red_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.yellow_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.gray_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.purple_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.light_blue_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.cyan_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.magenta_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_bed",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_bed"
        ],
        [
          "item.minecraft.light_gray_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.flower_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.oxeye_daisy"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.sunflower"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dandelion"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.warped_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_warped_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_crimson_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_birch_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_jungle_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_spruce_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_dark_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_acacia_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.poppy"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.rose_bush"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.red_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.beetroot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.redstone",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.redstone_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.mushroom_stew",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "item.minecraft.bowl"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lectern",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.bookshelf"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.heavy_weighted_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_polished_blackstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_slab"
        ],
        [
          "block.minecraft.polished_blackstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.crimson_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.blue_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.lapis_lazuli"
        ]
      ]
    },
    {
      "output": "item.minecraft.blue_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.cornflower"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lime_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sticky_piston",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.slime_ball"
        ],
        [
          "block.minecraft.piston"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.emerald",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.emerald_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smithing_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.painting",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.white_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.yellow_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.green_wool",
          "block.minecraft.red_wool",
          "block.minecraft.black_wool"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_nugget",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.fletching_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.flint"
        ],
        [
          "item.minecraft.flint"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.jungle_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.spruce_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.oak_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.dark_oak_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.birch_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.acacia_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.yellow_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lapis_lazuli",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lapis_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bowl",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sandstone_slab"
        ],
        [
          "block.minecraft.sandstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.cut_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.writable_book",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.ink_sac"
        ],
        [
          "item.minecraft.feather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_bars",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "item.minecraft.quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.cut_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.coarse_dirt",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dirt"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.dirt"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.piston",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.glistering_melon_slice",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sandstone_slab"
        ],
        [
          "block.minecraft.red_sandstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.carrot_on_a_stick",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.fishing_rod"
        ],
        [
          "item.minecraft.carrot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.birch_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.netherite_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.netherite_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.netherite_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_torch",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.coal",
          "item.minecraft.charcoal"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.soul_sand",
          "block.minecraft.soul_soil"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oak_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.cyan_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.green_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.shears",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.activator_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.grindstone",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.stone_slab"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.daylight_detector",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.blaze_powder",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_sword",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.light_blue_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_blue_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.blue_orchid"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lead",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_shovel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tripwire_hook",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chest",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smoker",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.furnace"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.jack_o_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.carved_pumpkin"
        ],
        [
          "block.minecraft.torch"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.melon_seeds",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.melon_slice"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.rabbit_stew",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.baked_potato"
        ],
        [
          "item.minecraft.cooked_rabbit"
        ],
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "block.minecraft.brown_mushroom"
        ]
      ]
    },
    {
      "output": "item.minecraft.rabbit_stew",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.baked_potato"
        ],
        [
          "item.minecraft.cooked_rabbit"
        ],
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "block.minecraft.red_mushroom"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stonecutter",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bucket",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.spruce_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.snow_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.furnace_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.furnace"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.sugar",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.sugar_cane"
        ]
      ]
    },
    {
      "output": "item.minecraft.sugar",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.honey_bottle"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.spruce_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bone_meal",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.bone_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.bone_meal",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.bone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.black_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.wither_rose"
        ]
      ]
    },
    {
      "output": "item.minecraft.black_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.ink_sac"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_torch",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lilac"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.allium"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.tnt_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.tnt"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gold_nugget",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_horse_armor",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone_brick_slab"
        ],
        [
          "block.minecraft.stone_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lever",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.iron_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.iron_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_pillar",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.purpur_slab"
        ],
        [
          "block.minecraft.purpur_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.shulker_box",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.shulker_shell"
        ],
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.shulker_shell"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.emerald_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.coal",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.coal_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.beetroot_soup",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.glass_bottle",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.honeycomb_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.hopper",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_red_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lodestone",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.honey_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.sandstone",
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.comparator",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_sword",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.jukebox",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.anvil",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_block"
        ],
        [
          "block.minecraft.iron_block"
        ],
        [
          "block.minecraft.iron_block"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.cookie",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.cocoa_beans"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.slime_ball",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.slime_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fire_charge",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gunpowder"
        ],
        [
          "item.minecraft.blaze_powder"
        ],
        [
          "item.minecraft.coal",
          "item.minecraft.charcoal"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.observer",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.compass",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_rod",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_axe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.warped_fungus_on_a_stick",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.fishing_rod"
        ],
        [
          "block.minecraft.warped_fungus"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_basalt",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.hay_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.magma_cream",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blaze_powder"
        ],
        [
          "item.minecraft.slime_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.turtle_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.scute"
        ],
        [
          "item.minecraft.scute"
        ],
        [
          "item.minecraft.scute"
        ],
        [
          "item.minecraft.scute"
        ],
        [
          "item.minecraft.scute"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.purple_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cartography_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bread",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.creeper_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.creeper_head"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chain",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_quartz_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.enchanting_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_axe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cauldron",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.crimson_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.acacia_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_lamp",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.snow",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.snow_block"
        ],
        [
          "block.minecraft.snow_block"
        ],
        [
          "block.minecraft.snow_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.coal_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.map",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.compass"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lime_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.vine"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stick",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ]
      ]
    },
    {
      "output": "item.minecraft.stick",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_shovel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "block.minecraft.soul_torch"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_wart_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gold_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.gold_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.gold_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.melon",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_carrot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.honey_bottle",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.honey_block"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.minecart",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.gold_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.shield",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.furnace",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.clay",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_bricks",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_apple",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.apple"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.paper",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sugar_cane"
        ],
        [
          "block.minecraft.sugar_cane"
        ],
        [
          "block.minecraft.sugar_cane"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.chest_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bone_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dispenser",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.bow"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diamond_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_quartz_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.mojang_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.enchanted_golden_apple"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_pillar",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.barrel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.target",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.hay_block"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.crossbow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.tripwire_hook"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.white_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lapis_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.diamond_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.flint_and_steel",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.flint"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sea_lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.spectral_arrow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.arrow"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dropper",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.beacon",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.nether_star"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.trapped_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "block.minecraft.tripwire_hook"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_campfire",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.soul_sand",
          "block.minecraft.soul_soil"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.vine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bookshelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pink_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pink_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.peony"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.book",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_door",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.loom",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.composter",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.acacia_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_quartz_block",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_slab"
        ],
        [
          "block.minecraft.quartz_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blue_ice",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.dried_kelp",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dried_kelp_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.ender_eye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.ender_pearl"
        ],
        [
          "item.minecraft.blaze_powder"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.brown_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.cocoa_beans"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.note_block",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.beehive",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.skull_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.wither_skeleton_skull"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "block.minecraft.torch"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.arrow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.flint"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.feather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.slime_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_hoe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brewing_stand",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fermented_spider_eye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.spider_eye"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "item.minecraft.sugar"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.conduit",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.heart_of_the_sea"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.powered_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.clock",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.magma_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wheat",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.hay_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.packed_ice",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone",
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.nether_brick_slab"
        ],
        [
          "block.minecraft.nether_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blast_furnace",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.furnace"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.campfire",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.coal",
          "item.minecraft.charcoal"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ],
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.warped_stem",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.stripped_warped_hyphae"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.respawn_anchor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.glowstone",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.crafting_table",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.acacia_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.scaffolding",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cake",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.egg"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_stone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.torch",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.coal",
          "item.minecraft.charcoal"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.light_weighted_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.flower_pot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tnt",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.sand",
          "block.minecraft.red_sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.sand",
          "block.minecraft.red_sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.sand",
          "block.minecraft.red_sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.sand",
          "block.minecraft.red_sand"
        ],
        [
          "item.minecraft.gunpowder"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.armor_stand",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.smooth_stone_slab"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.ender_chest",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "item.minecraft.ender_eye"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pumpkin_pie",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pumpkin"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.egg"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dried_kelp_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.ladder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.item_frame",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.end_crystal",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.ender_eye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.hopper_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.hopper"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pumpkin_seeds",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pumpkin"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_hoe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.cobblestone",
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ]
]
export const RecipeGroups = recipe_groups;